import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  width: 0,
  height: 0,
  isLandscape: "notSet",
  // array of errors
  arrErrors: [],
	userInteraction: false,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    onResize: (state: any, action: any) => {
      const { width, height, isLandscape } = action.payload;
      return {
        ...state,
        width,
        height,
        isLandscape,
      };
    },
    pushError: (state: any, action: any) => {
      return { ...state, arrErrors: [...state.arrErrors, action.payload] };
    },
    popError: (state, action) => {
      let errorsArr = [...state.arrErrors];
      errorsArr.shift();
      return { ...state, arrErrors: [...errorsArr] };
    },
    onInteraction: (state: any, action: any) => {
      return { ...state, userInteraction: action.payload };
    },
  },
});

export const { onResize, pushError, popError, onInteraction } =
  appSlice.actions;

export default appSlice.reducer;
